export const byteArrayToHexString = (byteArray: Int16Array | Array<number>) => {
  return Array.prototype.map
    .call(byteArray, function (byte) {
      return ("0" + (byte & 0xff).toString(16)).slice(-2);
    })
    .join("-")
    .toUpperCase();
};

export const stringToHexString = (str: string) => {
  let arr: Array<number> = [];
  for (let i = 0; i < str.length; i++) {
    arr.push(str.charCodeAt(i));
  }

  return byteArrayToHexString(arr);
};
